import { __assign } from "tslib";
export var defaults = function (object, source) {
    var result = __assign({}, object);
    var props = Object.keys(source);
    var propsIndex = -1;
    var propsLength = props.length;
    while (++propsIndex < propsLength) {
        var key = props[propsIndex];
        var value = result[key];
        if (value === undefined || !result.hasOwnProperty(key)) {
            result[key] = source[key];
        }
    }
    return result;
};
//# sourceMappingURL=utils.js.map